/**
 * @flow
 * @relayHash 16eab8b77266e3b9d4c79c7a9f05925c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProductsTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type ProductsTable_RefetchQueryVariables = {|
  host: string,
  limit?: ?number,
  offset?: ?number,
  sourceUrl?: ?TextFilters,
|};
export type ProductsTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: ProductsTable_project$ref
  |}
|};
export type ProductsTable_RefetchQuery = {|
  variables: ProductsTable_RefetchQueryVariables,
  response: ProductsTable_RefetchQueryResponse,
|};
*/


/*
query ProductsTable_RefetchQuery(
  $host: String!
  $limit: Int
  $offset: Int
  $sourceUrl: TextFilters
) {
  project(host: $host) {
    ...ProductsTable_project_1Kbbtr
    id
  }
}

fragment ProductsTable_project_1Kbbtr on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        products(offset: $offset, limit: $limit, sourceUrl: $sourceUrl) {
          count
          edges {
            node {
              ...ProductsRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ProductsRow_issue on Product {
  id
  source_url
  schema
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ProductsTable_RefetchQuery",
  "id": null,
  "text": "query ProductsTable_RefetchQuery(\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $sourceUrl: TextFilters\n) {\n  project(host: $host) {\n    ...ProductsTable_project_1Kbbtr\n    id\n  }\n}\n\nfragment ProductsTable_project_1Kbbtr on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        products(offset: $offset, limit: $limit, sourceUrl: $sourceUrl) {\n          count\n          edges {\n            node {\n              ...ProductsRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ProductsRow_issue on Product {\n  id\n  source_url\n  schema\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ProductsTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProductsTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ProductsTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "products",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "sourceUrl",
                            "variableName": "sourceUrl",
                            "type": "TextFilters"
                          }
                        ],
                        "concreteType": "ProductConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProductEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Product",
                                "plural": false,
                                "selections": [
                                  v2,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "schema",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2b2d2055d3bcd7ccf53a193f2ad7e7ff';
module.exports = node;
